import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

export default function getMsalInstance(): PublicClientApplication {
	return msalInstance;
}